import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postMBMPointData } from "services/ConfigServices";
import  Chart  from "react-google-charts";
import moment from "moment";
import "./sankey.css";
import { typeData, stateData } from "variables/MITM/lists/computer";
import { dateFormat } from "highcharts";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));


const colors = ['#a6cee3', '#b2df8a', '#fb9a99', '#fdbf6f',
  '#cab2d6', '#ffff99', '#1f78b4', '#33a02c'];

const options = {
  // height: 400,
  tooltip: { isHtml: true },
  sankey: {
    node: {
      colors: colors,
      interactivity: true,
    },
    link: {
      colorMode: 'gradient',
      colors: colors
    }
  }
};


function EnergyPoliciesSankey(props) {

  const { computers, policies } = props;

  const [loading, setLoading] = useState(false);
  const [pointlist, setPointlist] = useState([]);
  const [avobpointlist, setAvobpointlist] = useState([]);

  const [data, setData] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    let datatmp = [];
    datatmp.push([{
      type: "string",
      label: "From",
      id: "a"
    },
    {
      type: "string",
      label: "To",
      id: "b"
    },
    {
      type: "number",
      label: "PC",
      id: "c"
    },
    {
      type: "string",
      role: "tooltip",
      id: "d",
      p: { html: true }
    }]);
    let desktoptoviewer = 0;
    let desktoptosaver = 0;
    let laptoptoviewer = 0;
    let laptoptosaver = 0;
    let desktoppolicies = {};
    let laptoppolicies = {};
    // console.log(computers);
    computers.forEach((computer) => {
      if (computer.state === 0) {
        if (computer.typepc === 1)
          desktoptoviewer++;
        else if (computer.typepc === 2)
          laptoptoviewer++;
      }
      else if (computer.state === 1) {
        if (computer.typepc === 1)
          desktoptosaver++;
        else if (computer.typepc === 2)
          laptoptosaver++;
      }
      if (computer.typepc === 1) {
        if (desktoppolicies[computer.policy])
          desktoppolicies[computer.policy]++;
        else
          desktoppolicies[computer.policy] = 1;
      }
      else if (computer.typepc === 2) {
        if (laptoppolicies[computer.policy])
          laptoppolicies[computer.policy]++;
        else
          laptoppolicies[computer.policy] = 1;
      }

    })
    Object.keys(desktoppolicies).forEach(function (key) {
      let pccount = desktoppolicies[key];
      let policyname = policies.find((pol) => pol.id == key).name;
      let typename = typeData.find((type) => type.id == 1).name;
      datatmp.push([policyname, typename, pccount, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + policyname + "'</b> -> <b>'" + typename + "'</b></p>" +
        "<p>" + pccount + " PC </p>" +
        "</div>"]);
    });
    Object.keys(laptoppolicies).forEach(function (key) {
      let pccount = laptoppolicies[key];
      let policyname = policies.find((pol) => pol.id == key).name;
      let typename = typeData.find((type) => type.id == 2).name;
      datatmp.push([policyname, typename, pccount, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + policyname + "'</b> -> <b>'" + typename + "'</b></p>" +
        "<p>" + pccount + " PC </p>" +
        "</div>"]);
    });
    let viewername = stateData.find((state) => state.id == 0).name;
    let savername = stateData.find((state) => state.id == 1).name;
    let desktopname = typeData.find((type) => type.id == 1).name;
    let laptopname = typeData.find((type) => type.id == 2).name;

    if (desktoptoviewer > 0 || desktoptosaver > 0) {
      datatmp.push([desktopname, viewername, desktoptoviewer, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + desktopname + "'</b> -> <b>'" + viewername + "'</b></p>" +
        "<p>" + desktoptoviewer + " PC </p>" +
        "</div>"]);
      datatmp.push([desktopname, savername, desktoptosaver, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + desktopname + "'</b> -> <b>'" + savername + "'</b></p>" +
        "<p>" + desktoptosaver + " PC </p>" +
        "</div>"]);
    }
    if (laptoptoviewer > 0 || laptoptosaver > 0) {
      datatmp.push([laptopname, viewername, laptoptoviewer, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + laptopname + "'</b> -> <b>'" + viewername + "'</b></p>" +
        "<p>" + laptoptoviewer + " PC </p>" +
        "</div>"]);
      datatmp.push([laptopname, savername, laptoptosaver, "<div class=\"avob-tooltip\">" +
        "<p><b>'" + laptopname + "'</b> -> <b>'" + savername + "'</b></p>" +
        "<p>" + laptoptosaver + " PC </p>" +
        "</div>"]);
    }
    setData(datatmp);
  }, [computers]);




  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          {
            loading ?
              <GridItem xs={12} sm={12} md={12} lg={12}><div style={{ paddingTop: "12px", marginLeft: "35%" }}></div></GridItem>
              :

              <GridItem xs={12} sm={12} md={12} lg={12}>

                {
                  (data && data.length > 1) ?
                    <Chart
                      chartType="Sankey"
                      width="100%"
                      height="500px"
                      data={data}
                      options={options}
                    />
                    : <>
                    </>
                }

              </GridItem>


          }
        </GridContainer>
      </form>
    </>
  );
}

export default EnergyPoliciesSankey;
